import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Sun, Moon } from 'lucide-react';
import { getTheme, toggleTheme } from '@/lib/theme';

// Light/dark switch used in every portal header. Remembers the user's choice.
export const ThemeToggle = ({ className = '' }) => {
  const [theme, setTheme] = useState(getTheme());
  return (
    <Button variant="ghost" size="icon" className={className}
      onClick={() => setTheme(toggleTheme())}
      title={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
      aria-label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
      data-testid="theme-toggle">
      {theme === 'dark' ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
    </Button>
  );
};
